class WhIllegalArgumentException extends Error {
    constructor(message) {
        super();
        this.message = message;
    }
}

export default WhIllegalArgumentException


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhIllegalArgumentException.js